import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@letly/models';
import { ApiService } from '@letly/services';
import { PropertyListRes } from '../../../list-view/models/property-list.res';
import { environment } from '../../../../env/environment';

@Injectable({
  providedIn: 'root',
})
export class LandlordListingService {

  private apiService = inject(ApiService);

  getProperties(page: number, _status?: string): Observable<ApiResponse<PropertyListRes>> {
    return this.apiService.get(environment.listingBaseUrl + `/v1/landlords/self/properties?page=${page}`);
  }
}
